/* eslint-disable no-restricted-syntax -- SafeHtmlPipe is the single authorised bypass point for DomSanitizer.
   All callers (message-body, column, ui-grid, column-detail, power-bi-report, dashboard-viewer) render
   server-sourced HTML/URLs through this centralised pipe so every bypass is auditable in one place. */
import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitized = inject(DomSanitizer);


  transform(value: string, type?: string): SafeHtml {
    switch (type) {
      case 'url':
        return this.sanitized.bypassSecurityTrustResourceUrl(value);
      default:
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
  }
}
